import { useCallback, useRef, useState } from "react";
import { useMount, useUnmount } from "react-use";

type UseModalVisibility = {
  onClose?: VoidFunction;
  onBeforeClose?: (closeFunction: VoidFunction) => boolean;
};

const ANIMATION_DURATION_MS = 500;

export const useModalVisibility = ({ onClose, onBeforeClose }: UseModalVisibility) => {
  const [fadeIn, setFadeIn] = useState(false);
  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const closeWithAnimation = useCallback(
    (withBeforeClose = true) => {
      const doClose = () => {
        setFadeIn(false);
        closeTimeoutRef.current = setTimeout(() => {
          onClose?.();
        }, ANIMATION_DURATION_MS);
      };

      if (withBeforeClose && onBeforeClose?.(doClose) === false) {
        return;
      }

      doClose();
    },
    [onBeforeClose, onClose]
  );

  useMount(() => {
    setFadeIn(true);
  });

  useUnmount(() => {
    clearTimeout(closeTimeoutRef.current);
  });

  return {
    fadeIn,
    closeWithAnimation
  };
};
